import { render } from "./flbDetail.vue?vue&type=template&id=7c70a8e7"
import script from "./flbDetail.vue?vue&type=script&lang=js"
export * from "./flbDetail.vue?vue&type=script&lang=js"

import "./flbDetail.vue?vue&type=style&index=0&id=7c70a8e7&lang=scss"

import exportComponent from "/Users/wanggaochao/项目/善城 (2)/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__